import { api } from '@/modules/apiv2';

export default {
  state: {
    summary: null,
  },

  getters: {
    summary(state) {
      return state.summary;
    },
  },

  mutations: {
    setSummary(state, summary) {
      state.summary = summary;
    },
  },

  actions: {
    getSummary({ commit, getters }) {
      const endpoint = getters.summaryEndpoint;

      return api
        .get(endpoint)
        .then((data) => {
          commit('setSummary', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    updateSummary({ commit, getters }, data) {
      const endpoint = getters.summaryEndpoint;

      return api
        .patch(endpoint, data)
        .then((data) => {
          commit('setSummary', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
